<template>
  <div>
    <v-dialog      
    v-model="dialog"
      v-if="$vuetify.breakpoint.mdAndUp"
  
  max-width="65vw"
      :hide-overlay="false"
      transition="dialog-bottom-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-icon :class="[{ 'mt-n4': $vuetify.breakpoint.smAndDown }]" size="25" color="primary" dark 
          @click="cargarDatos(numerodoc, tipodoc);
          datosTitulo(idtab);" 
          v-on="on"
          v-bind="attrs"
        v-if="idtab === 1">
          mdi-file-outline
        </v-icon>
      </template>
    
          <v-card c  color="white"
            light
          
            width="65vw"
            height="auto"
            
            outlined>
            <v-toolbar dense class="primary elevation-0" height="40">

              <v-spacer></v-spacer>
              <v-toolbar-title class="white--text">
                {{ getNombreTipDoc ? getNombreTipDoc.StatusPed : "" }}
                {{ `N° ${ numerodoc } ` }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false" large>
                <v-icon large color="white">mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

          <!--   <v-card class="pa-2">
              <v-img contain :src=" `${domoapi2_img}Cia/1/encabezado?archivo=2.jpg` " width="500">
              </v-img>
            </v-card> -->

         
            <v-skeleton-loader
              class="mx-auto"
              max-width="70vw"
              type="table"
              v-if=" !getNombreTipDoc"
            >
            </v-skeleton-loader>
            <v-row no-gutters v-if=" getNombreTipDoc ">
              <template>
                <v-col cols="6">
                  <v-card flat tile>
                     <v-list-item three-line dense>
                      <v-list-item-content>
                         <v-list-item-title class="d-flex justify-space-between">
                           <span class="primary--text text-body-2">
                              {{ `${ "Presupuesto N°:" } ` }}
</span>
 <span class="primary--text font-weight-bold text-body-2">
   {{getNombreTipDoc ? getNombreTipDoc.NumeroPedido : ''}}
 </span>
                         </v-list-item-title>
                          <v-list-item-subtitle 
                      
                           class="d-flex justify-space-between">
 <span class="primary--text text-body-2">Codigo Cliente: </span>
 <span class="primary--text font-weight-bold text-body-2">
  {{getNombreTipDoc ? getNombreTipDoc.CodigoCli : ''}}
 </span>
 </v-list-item-subtitle>
 <v-list-item-subtitle 
                      
                           class="d-flex justify-space-between">
 <span class="primary--text text-body-2">Cliente: </span>
 <span class="primary--text font-weight-bold text-body-2">
  {{ `${ getNombreTipDoc ? getNombreTipDoc.NombreCli : '' } ` }}
 </span>
 </v-list-item-subtitle>
 <v-list-item-subtitle 
                      
                           class="d-flex justify-space-between">
 <span class="primary--text text-body-2"> Condición de Pago: </span>
 <span class="primary--text font-weight-bold text-body-2">
   {{ `${ getNombreTipDoc ? getNombreTipDoc.CondicionPago : '' } ` }}
 </span>
 </v-list-item-subtitle>
                      </v-list-item-content>
                     </v-list-item>
                   
                  </v-card>
                </v-col>

               <v-col cols="6">
                  <v-card flat tile>
                      <v-list-item three-line dense>
                         <v-list-item-content>
                            <v-list-item-title class="d-flex justify-space-between">
  <span class="primary--text text-body-2">Estatus:
</span>
<span class="primary--text font-weight-bold text-body-2">
  {{ getNombreTipDoc ? getNombreTipDoc.StatusPed : '' }}
 </span>
 </v-list-item-title>
 <v-list-item-subtitle 
                         
                           class="d-flex justify-space-between">
 <span class="primary--text text-body-2">Fecha de Pedido:</span>
 <span class="primary--text font-weight-bold text-body-2">
  {{
                        getNombreTipDoc ?
                        getNombreTipDoc.FechaPedido
                        ? moment(getNombreTipDoc.FechaPedido).format(
                        "DD/MM/YY"
                        )
                        : ""
                        :''
                        }}
</span>
 </v-list-item-subtitle>
 <v-list-item-subtitle 
                         
                           class="d-flex justify-space-between">
 <span class="primary--text text-body-2">Fecha Vencimiento:</span>
 <span class="primary--text font-weight-bold text-body-2">
  {{
                        getNombreTipDoc ?
                        getNombreTipDoc.FechaPedido
                        ? moment(getNombreTipDoc.FechaPedido)
                        .add(10, "days")
                        .format("DD/MM/YY")
                        : ""
                        :''
                        }}
</span>
 </v-list-item-subtitle>
 <v-list-item-subtitle 
                         
                           class="d-flex justify-space-between">
 <span class="primary--text text-body-2"> Tipo Pedido:</span>
 <span class="primary--text font-weight-bold text-body-2">
   {{ getNombreTipDoc ? getNombreTipDoc.TipoPedido :''}}
</span>
 </v-list-item-subtitle>
                         </v-list-item-content>
                      </v-list-item>
                   
                  </v-card>
                </v-col>
              </template>
            </v-row>
            <p class="text-h6 text-center mt-6">{{getNombreTipDoc && pedItemsPedido.length===0 ? 'Sin Articulos' : '' }}
            </p>


            <v-container grid-list-md v-if=" pedItemsPedido.length != 0 ">
              <v-row 
              no-gutters 
              align="start" 
              justify="center">
                <v-col cols="12">
                  <v-data-table 
                  v-if=" pedItemsPedido.length != 0 " 
                  dense :headers=" headersPresupuesto "
                    :items=" pedItemsPedido " 
                   
                    class="elevation-0" 
                    hide-default-footer 
                    disable-pagination s
                    single-select
                    height="35vh"
                    fixed-header>
                   <template v-slot:[`item.Codigo`]="{ item }">
                      <figure class="d-flex flex-column justify-center align-center">
            <v-img :src="imgSrc(item.Codigo)" contain
      max-width="40" />
            <figcaption><span class="text-caption font-weight-bold">{{ item.Codigo }}</span></figcaption>
          </figure>

                    </template>
<template v-slot:[`item.Nombre`]="{ item }">
  <span class="d-flex  justify-start align-center">   {{ item.Nombre }}</span>
 
     </template>
     <template v-slot:[`item.Cantidad`]="{ item }">
  <span class="d-flex  justify-center align-center">   {{ item.Cantidad }}</span>
 

     </template>
             <template v-slot:[`item.PrecioUni`]="{ item }">
                <span class="d-flex  justify-end align-center">   {{ item.PrecioUni[tipoMoneda] | numeral("0,0.00")}}</span>
    </template>     
     <template v-slot:[`item.Descuento`]="{ item }">
                <span class="d-flex  justify-end align-center">   {{ item.Descuento }}</span>
    </template> 
             <template v-slot:[`item.PrecioNeto`]="{ item }">
                <span class="d-flex  justify-end align-center">   {{ item.PrecioNeto[tipoMoneda] | numeral("0,0.00")}}</span>
    </template>
             <template v-slot:[`item.PrecioTot`]="{ item }">
                <span class="d-flex  justify-end align-center">   {{ item.PrecioTot[tipoMoneda] | numeral("0,0.00")}}</span>
    </template>
                   
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
<table class="d-flex justify-end mr-3" v-if=" pedItemsPedido.length != 0 " >
  <tbody>
     <tr>
                        <td colspan="4" id="bordebtn"></td>
                        <td colspan="2" id="borde" :class=" ['text-right '] ">
                          Monto Bruto
                        </td>
                        <td class="text-right" id="borde">
                          {{
                          totalItems.MontoBruto[tipoMoneda]
                          | numeral("0,0.00")
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td :colspan=" idtab === 1 ? 4 : idtab === 4 ? 5 : 5 " id="bordebtn"></td>
                        <td colspan="2" id="borde" :class=" ['text-right '] ">
                          Descuento
                        </td>
                        <td class="text-right" id="borde">
                          {{
                          totalItems.MontoDescuento[tipoMoneda]
                          | numeral("0,0.00")
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td :colspan=" idtab === 1 ? 4 : idtab === 4 ? 5 : 5 " id="bordebtn"></td>
                        <td colspan="2" id="borde" :class=" ['text-right '] ">
                          Monto Neto
                        </td>
                        <td class="text-right" id="borde">
                          {{
                          totalItems.MontoNeto[tipoMoneda] | numeral("0,0.00")
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4" id="bordebtn"></td>
                        <td colspan="2" id="borde" :class=" ['text-right '] ">
                          IVA
                        </td>
                        <td class="text-right" id="borde">
                          {{
                          totalItems.MontoIva[tipoMoneda] | numeral("0,0.00")
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4" id="bordebtn"></td>
                        <td colspan="2" id="borde" :class=" ['text-right'] ">
                          Monto Total
                        </td>
                        <td id="borde" :class=" ['black--text text-right font-weight-black'] ">
                          {{
                          totalItems.MontoTotal[tipoMoneda]
                          | numeral("0,0.00")
                          }}
                        </td>
                      </tr>
  </tbody>
</table>
      

    <v-divider></v-divider>

            <v-card-actions>
               <span class="font-weight-regular">
                  Generado por:  <span class="font-weight-bold">{{ `${ getNombreTipDoc ? getNombreTipDoc.Creado : '' } ` }}</span>
                </span>
              <v-spacer></v-spacer>
              <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition>
                <v-btn
                v-bind="attrs"
          v-on="on"
                  :color="`${tipoMoneda===1 ? 'success' : 'accent'}`"
                 class="elevation-0 mr-6"
                  dark
              small
              @click="changeMoneda(tipoMoneda===1 ? 0 : 1)"
                >
                  <v-icon left>mdi-swap-horizontal</v-icon>{{ `${tipoMoneda===1 ? '$' : 'Bs'}` }}
                </v-btn>
              </v-fab-transition>
      </template>
      <span>Cambiar Moneda a {{ `${tipoMoneda===1 ? 'Bs' : '$'}` }}</span>
    </v-tooltip>
               
            
              <v-btn small color="error" dark @click="dialog = false" class="elevation-0"> Cerrar </v-btn>

            </v-card-actions>
          </v-card>
        
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import imgPredet from "../components/ImgPred";
export default {
  data() {
    return {
      dialog: false,
      datos1: [],
      isMobile: false,
      tipoMoneda: 1,
           updateImg: Math.floor(Math.random() * 100),
    };
  },
  created() {
    // this.CLR_FACTDOC_PENDIENTES();
    //this.CLR_ITEMSFACTDOC_PENDIENTES();
    /*  this.facturaDocPendiente({
        NumeroDoc: this.numerodoc,
        TipoDoc: this.tipodoc,
      });*/
  },
  components: {
    imgPredet,
  },
  computed: {
    ...mapState([
      "factDocPendientes",
      "factDocItemsFactura",
      "simboloMoneda",
      "NoImg",
      "imgPeque",
      "pedDatosPedido",
      "pedItemsPedido",
      "pedTotalesPedido",
      "domoapi2_img"
    ]),
    tam() {
      return this.dataItems ? Object.keys(this.dataItems).length : 0;
    },
    headersPresupuesto() {
      return [
        {
          text: "Codigo",
          align: "center",
          value: "Codigo",
          groupable: false,
          sortable: false,
          divider: true,
          width: "20px",
          class: "subtitle-2 font-weight-bold d-print-none",
        },

        {
          text: "Nombre",
          align: "center",
          value: "Nombre",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Cantidad",
          align: "center",
          value: "Cantidad",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Precio",
          align: "center",
          value: "PrecioUni",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Descuento",
          align: "center",
          value: "Descuento",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Precio Neto",
          align: "center",
          value: "PrecioNeto",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Precio Total",
          align: "center",
          value: "PrecioTot",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
      ];
    },
    headersDiferidos() {
      return [
        {
          text: "Codigo",
          align: "center",
          value: "Codigo",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },

        {
          text: "Nombre",
          align: "center",
          value: "Nombre",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Cantidad",
          align: "center",
          value: "Cantidad",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Precio",
          align: "center",
          value: "PrecioUni",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Descuento",
          align: "center",
          value: "Descuento",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Iva",
          align: "center",
          value: "",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Precio Neto",
          align: "center",
          value: "PrecioNeto",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Precio Total",
          align: "center",
          value: "PrecioTot",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
      ];
    },
    dataItems: function () {
      let obj = [];

      obj = JSON.parse(JSON.stringify(this.factDocPendientes));

      return obj;
    },
    totalItems() {
      if (Object.entries(this.pedTotalesPedido.length !== 0))
        return this.pedTotalesPedido[0];
    },
    //pedItemsPedido ,factDocItemsFactura
    getNombreTipDoc() {
      if (Object.entries(this.pedDatosPedido.length !== 0))
        return this.pedDatosPedido[0];
    },

    imgArt: function () {
      let urlImg = null;
      return function (id) {
        if (id != "") urlImg = `${this.imgPeque}${id}`;
        if (id === "") urlImg = `${this.NoImg}no_image.jpg`;
        return urlImg;
      };
    },
    /*
     return item === 1
        ? this.factDocPendientes[0].length
        : item === 4
        ? this.pedDatosPedido[0].length
        : null;
    }, */
  },
  methods: {
    ...mapActions(["facturaDocPendiente"]),
    ...mapMutations([
      "CLR_FACTDOC_PENDIENTES",
      "CLR_PEDIDO",
      "CLR_ITEMSFACTDOC_PENDIENTES",
    ]),
      changeMoneda(moneda) {
      this.tipoMoneda =moneda
    },
     imgSrc(code) {
      let xSrc = this.domoapi2_img;
      xSrc += "Articulo/";
      xSrc += this.ChrEsp(code);
      xSrc += "/Principal?";
      xSrc += "i=" + this.updateImg;

      return xSrc;
    },
        ChrEsp(chr) {
      const chrSplit = chr.split("");
      let newChr = "";

      chrSplit.forEach((x) => {
        if (x === "/") newChr += "-";
        else if (x === ".") newChr += "-";
        else newChr += x;
      });

      return newChr;
    },
    

    datosTitulo(item) {
      if (Object.entries(this.pedDatosPedido.length !== 0))
        return this.pedDatosPedido[0];
    },
    setAltImg(event) {
      event.target.src = `${this.NoImg}no_image.jpg`;
    },

    async cargarDatos(numd, tipod) {
      // await this.CLR_FACTDOC_PENDIENTES();
      // await this.CLR_ITEMSFACTDOC_PENDIENTES();
      this.CLR_PEDIDO();
    
      await this.facturaDocPendiente({ NumeroDoc: numd, TipoDoc: tipod });
      this.tipoMoneda = 1
    },
  },
  props: {
    tipodoc: Number,
    numerodoc: Number,
    idtab: Number,
    transi: Boolean
  },
};
</script>

<style scoped>
#borde {
  border-collapse: collapse;
  margin: 0;
  padding: 4px;

  border: 1px solid rgb(167, 163, 163);
}

#bordebtn {
  border-collapse: collapse;
  margin: 0;
  padding: 4px;
  border-bottom-style: solid;
  border-bottom-color: white;
  border-bottom-width: 1px;
}

#tbl_datos tr:nth-child(odd) {
  background: #ffffff;
  border-left: 6px solid #fe5000;
}

#tbl_datos tr:nth-child(even) {
  background: #eeeeee;
  border-left: 6px solid #002f6c;
}

.codigoart {
  font-size: 0.8rem;
  vertical-align: bottom;
  font-weight: bold;
  margin: 0 0px;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }

  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }

  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}

.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;

  height: 40px;
  font-weight: bold;
}

.flex-txt {
  padding: 6px;
  width: 50%;
  height: 45px;
}
</style>